import React from 'react'
import { useStyles } from '../FlyOutUsageMetering.styles'
import { ExternalLink } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons'
import { faPlay } from '@fortawesome/pro-regular-svg-icons'

const createMeteringRecordVideo = {
  video: 'https://app.supademo.com/demo/cmmj1t921238dzdh1bly25vln',
  linkText: 'Open in a new window',
}

export const MeteringVideoContainer: React.FC = () => {
  const { classes } = useStyles()

  const handleThumnailClick = () => {
    const newWind = window.open(
      'https://app.supademo.com/demo/cmmj1t921238dzdh1bly25vln',
      '_blank',
      'noopener,noreferrer'
    )
    if (newWind) {
      newWind.opener = null
    }
  }

  return (
    <div
      className={classes.demoVideoContainer}
      data-testid="video-usage-metering-details"
    >
      <div className={classes.videoHeader}>
        <div className={classes.playIcon}>
          <FontAwesomeIcon icon={faPlay} />
        </div>
        <span className={classes.videoText}>Instructional video</span>
      </div>

      <div className={classes.videoWrapper}>
        <div className={classes.thumbnailWrapper}>
          <img
            className={classes.thumbnailImages}
            src={'https://assets.flyout.labra.io/misc/metering.jpeg'}
            title="Labra FlyOut"
            alt={'usage-metering'}
            onClick={handleThumnailClick}
          />
          <FontAwesomeIcon
            icon={faCirclePlay}
            className={classes.playButton}
            onClick={handleThumnailClick}
            style={{
              width: '38px',
              height: '37px',
            }}
          />
        </div>
        <div data-testid="video-link-usage-metering">
          <ExternalLink href={createMeteringRecordVideo.video}>
            {createMeteringRecordVideo.linkText}
          </ExternalLink>
        </div>
      </div>
    </div>
  )
}
